'use client';

import React, { FC, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

import ShotikIcon from '@/public/icons/shotik.svg';

interface GenerateButtonProps {
  disabled: boolean;
  onClick: () => Promise<void>;
  text: string | ReactNode;
  price?: string;
}

const styles = {
  buttonTextDisabled: 'text-label-secondary',
  button:
    'sticky bottom-10 w-full left-5 right-5 bg-fill-button rounded-xl py-5 mt-8 block cursor-pointer',
  buttonDisabled: 'bg-fill-toast cursor-not-allowed',
  buttonText: 'text-label-black font-extrabold text-base text-center',
  iconWrap:
    'absolute right-5 top-[50%] translate-y-[-50%] flex gap-0.5 items-center',
  icon: 'w-5 h-5 text-label-black',
};

export const GenerateButton: FC<GenerateButtonProps> = ({
  disabled,
  onClick,
  text,
  price,
}) => (
  <button
    disabled={disabled}
    onClick={onClick}
    className={twMerge(styles.button, disabled && styles.buttonDisabled)}
  >
    <div
      className={twMerge(
        styles.buttonText,
        disabled && styles.buttonTextDisabled,
      )}
    >
      {text}
    </div>
    {price && (
      <div className={styles.iconWrap}>
        <div
          className={twMerge(
            styles.buttonText,
            disabled && styles.buttonTextDisabled,
          )}
        >
          {price}
        </div>

        <ShotikIcon
          className={twMerge(
            styles.icon,
            disabled && styles.buttonTextDisabled,
          )}
        />
      </div>
    )}
  </button>
);
